const NotFount = () =>{
  return (
    <div>NotFount 页面不存在</div>
  )
}

export default NotFount